import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { BuyParameters } from 'components';
import { get } from 'lodash';
import { RootState } from '../../types';
import { getFormatDate } from '../../utils/utils';

import './index.scss';

const BuyingInfoContainer: FC = () => {
  const purchase: any = useSelector(
    (state: RootState) => state.operationsSign.data.purchase
  );

  return (
    <div className="buying-info">
      <div className="mb_24">
        <BuyParameters />
      </div>
      <h3 className="h3">
        <strong>Реквизиты платежа:</strong>
      </h3>
      <p>
        <br />
        {get(purchase, 'agentCompanyInfo.shortName', '')}
        <br />
        ИНН / КПП: {get(purchase, 'agentCompanyInfo.tin', '') + " / " + get(purchase, 'agentCompanyInfo.kpp', '')}
        <br />
        ОГРН: {get(purchase, 'agentCompanyInfo.regNumber', '')}
        <br />
        Адрес: {get(purchase, 'agentCompanyInfo.address', '')}
        <br />
        <br />
        <strong>Банковские реквизиты:</strong>
        <br />
        <br />
        Р/С: {get(purchase, 'agentBankAccount.accountNumber', '')}
        <br />
        Банк: {get(purchase, 'agentBankAccount.bankName', '')}
        <br />
        БИК: {get(purchase, 'agentBankAccount.bik', '')}
        <br />
        К/С: {get(purchase, 'agentBankAccount.corrAccountNumber', '')}
      </p>
      <br />
      <h3>Основание платежа:</h3>
      <p>{`Оплата ЦФА по договору купли-продажи №${
        purchase?.id
      } от ${getFormatDate(purchase?.createdAt, undefined, true)}. Без НДС`}</p>
    </div>
  );
};

export default BuyingInfoContainer;
